'use es6';

import { ROW_CLASSNAME, SECTION_CLASSNAME } from 'layout-data-lib/constants';
import { ROW_ATTRIBUTE, ROW_TREE_ATTRIBUTE } from '../constants/dndAreaDomConstants';
import { buildDndAreaRowId, buildDndAreaRowTreeId, getDndAreaCellElement, getDndAreaElement, getDndAreaRowElementByIndex } from '../dom/dndAreaDomSelectors';
import { addOrRemoveClassesToElement } from '../dom/manipulators';
import { forEachTree } from '../layoutTreeIterators';
export const setDndAreaRowId = (rowElement, parentColumnId, index) => {
  if (rowElement) {
    rowElement.setAttribute(ROW_ATTRIBUTE, buildDndAreaRowId(parentColumnId, index));
  }
};
export const setDndAreaRowTreeId = (rowElement, parentColumnId, id) => {
  if (rowElement) {
    rowElement.setAttribute(ROW_TREE_ATTRIBUTE, buildDndAreaRowTreeId(parentColumnId, id));
  }
};
export const getLayerChildren = treeItem => {
  const isRow = treeItem.isRow();
  const isStaticSection = treeItem.isStaticSection();
  if (isStaticSection) {
    return treeItem.getModuleChildren();
  }
  if (isRow) {
    return treeItem.getColumns();
  }
  return treeItem.getRows();
};
export const updateRowElementClasses = (element, currentRowClasses = '', previousRowClasses = '') => {
  if (currentRowClasses || previousRowClasses) {
    const previousClasses = previousRowClasses ? previousRowClasses.split(' ') : [];
    const currentClasses = currentRowClasses ? currentRowClasses.split(' ') : [];
    addOrRemoveClassesToElement(element, previousClasses, currentClasses);
  }
};
export const createDndAreaRowElement = ({
  isSection = false,
  rowParams = null
} = {}) => {
  const element = document.createElement('div');
  const fluidRowDiv = document.createElement('div');
  element.className = 'row-fluid-wrapper';
  if (isSection) {
    element.classList.add(SECTION_CLASSNAME);
    if (rowParams && rowParams.cssClass) {
      updateRowElementClasses(element, rowParams.cssClass);
    }
  } else {
    element.classList.add(ROW_CLASSNAME);
  }
  fluidRowDiv.className = 'row-fluid';
  element.appendChild(fluidRowDiv);
  return element;
};
const addTreeIdToLayer = (treeItems, parentColumnId, parentColumnElement) => {
  for (let i = 0; i < treeItems.length; i++) {
    const treeItem = treeItems[i];
    const isRow = treeItem.isRow();

    // staticSection is also a row, and included here.
    if (isRow) {
      const element = getDndAreaRowElementByIndex(parentColumnId, i);
      setDndAreaRowTreeId(element, parentColumnId, treeItem.getName());
    }
    const layerChildren = getLayerChildren(treeItem);
    if (layerChildren.length) {
      if (!isRow) {
        parentColumnId = treeItem.getName();
        const newParentColumnElement = getDndAreaCellElement(parentColumnId);
        addTreeIdToLayer(layerChildren, parentColumnId, newParentColumnElement);
      } else {
        addTreeIdToLayer(layerChildren, parentColumnId, parentColumnElement);
      }
    }
  }
};
export const addTreeIdsToRowsInDom = layoutTrees => {
  forEachTree(layoutTrees, tree => {
    const root = tree.getRootCell();
    const treeElement = getDndAreaElement(root.getName());
    addTreeIdToLayer(root.getRows(), root.getName(), treeElement);
  });
};